import { DocumentationLinkPreview } from "@supernova-studio/model";
import { z } from "zod";
//
// Read
//
export const DTODocumentationLinkPreviewResponse = z.object({
    linkPreview: DocumentationLinkPreview,
});
//
// Write
//
export const DTODocumentationLinkPreviewRequest = z.object({
    url: z.string().optional(),
    documentationItemPersistentId: z.string().optional(),
});
